<template>
  <div class="expert-card">
    <div class="expert-avatar">
      <div class="expert-avatar__inner">
        <div class="expert-avatar__face expert-avatar__front" :style="{ backgroundColor: bgColor }">
          <picture>
            <img :src="image" :srcset="srcset" :alt="imageAlt || name" width="120" height="120" loading="lazy" decoding="async">
          </picture>
        </div>
        <div class="expert-avatar__face expert-avatar__back" :style="{ backgroundColor: bgColor }">
          <span class="expert-avatar__back-name">{{ name }}</span>
          <span class="expert-avatar__back-role">{{ role }}</span>
        </div>
      </div>
    </div>
    <h3 class="expert-name">{{ name }}</h3>
    <p class="expert-role">{{ role }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name: string
  role: string
  image: string
  imageAlt?: string
  srcset?: string
  bgColor?: string
}

withDefaults(defineProps<Props>(), {
  bgColor: 'var(--color-avatar-beige)'
})
</script>

<style scoped>
.expert-card {
  text-align: center;
}

/* 3D переворот: при наведении круг переворачивается и показывает обратную сторону */
.expert-avatar {
  width: min(305px, 100%);
  aspect-ratio: 1;
  margin: 0 auto 20px;
  perspective: 520px;
  border-radius: 50%;
  overflow: hidden;
}

.expert-avatar__inner {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform-style: preserve-3d;
  /* Тимчасово вимкнено hover-анімацію */
  /* transition: transform 0.7s cubic-bezier(0.4, 0, 0.2, 1); */
}

.expert-card:hover .expert-avatar__inner {
  /* transform: rotateY(180deg); */
}

.expert-avatar__face {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.expert-avatar__front {
  background-color: var(--color-avatar-beige);
}

.expert-avatar__front picture {
  display: block;
  width: 100%;
  height: 100%;
}

.expert-avatar__front img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.expert-avatar__back {
  transform: rotateY(180deg);
  padding: 24px;
  text-align: center;
}

.expert-avatar__back-name {
  font-family: var(--font-inter);
  font-weight: var(--font-weight-semibold);
  font-size: 17px;
  line-height: 1.3;
  color: var(--color-dark-blue);
  margin-bottom: 6px;
}

.expert-avatar__back-role {
  font-family: var(--font-inter);
  font-weight: var(--font-weight-regular);
  font-size: 13px;
  line-height: 1.35;
  color: var(--color-grey);
}

.expert-name {
  font-family: var(--font-inter);
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  color: var(--color-dark-blue);
  margin-bottom: 4px;
}

.expert-role {
  font-family: var(--font-inter);
  font-weight: var(--font-weight-regular);
  font-size: 14px;
  color: var(--color-grey);
}

@media (max-width: 991px) {
  .expert-avatar {
    width: min(180px, 100%);
  }

  .expert-avatar__back {
    padding: 16px;
  }

  .expert-avatar__back-name {
    font-size: 14px;
  }

  .expert-avatar__back-role {
    font-size: 11px;
  }
}

@media (max-width: 575px) {
  .expert-avatar {
    width: min(150px, 100%);
  }

  .expert-avatar__back {
    padding: 12px;
  }

  .expert-avatar__back-name {
    font-size: 13px;
  }

  .expert-avatar__back-role {
    font-size: 10px;
  }

  .expert-name {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .expert-avatar {
    width: min(250px, 100%);
  }
.expert-name {
    font-size: 18px;
  }
}
</style>

